import { render, staticRenderFns } from "./tablaMarcas.vue?vue&type=template&id=c520b6d6&scoped=true&"
import script from "./tablaMarcas.vue?vue&type=script&lang=js&"
export * from "./tablaMarcas.vue?vue&type=script&lang=js&"
import style0 from "./tablaMarcas.vue?vue&type=style&index=0&id=c520b6d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c520b6d6",
  null
  
)

export default component.exports